import ChannelTabs from './ChannelTabs'

export default ChannelTabs



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/index.js